import { Component, OnInit, Renderer2 } from '@angular/core';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { environment } from '../../../../environments/environment';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit {
  public searchText: string;
  public appName: string = null;
  constructor(private commonService: TCCPCommonService, private storageService: TCCPLocalStorageService,
    private renderer: Renderer2) { }

  ngOnInit() {
    this.appName = environment.applicationName;
    this.hideBackgroundImage();
    this.commonService.hideBreadrumb.emit(true);
  }

  hideBackgroundImage() {
    this.commonService.setBackground(this.renderer, this.appName);
  }

  onCloseSearchPage() {
    window.history.back();
  }

}
